import defaultTokens, {
  type LinkTokens,
} from '@agria/theme/src/components/link/tokens';

const tokens: LinkTokens = {
  ...defaultTokens,
  circleBorderColor: 'brandTwo',
  circleHoverBorderColor: 'brandTwo',
  circleHoverBackgroundColor: 'brandTwo10',
  hoverColour: 'brandTwo100',
} as const;

export default tokens;
